export default __webpack_public_path__ + "static/media/whyChooseUsIcon4.33048431.webp";